<template>
  <div class="min-h-screen bg-bg">
    <Sidebar
      v-if="showNav"
      v-model:collapsed="sidebarCollapsed"
    />
    <main
      class="transition-[padding-left] duration-200 ease-in-out"
      :class="showNav ? (sidebarCollapsed ? 'pl-[72px]' : 'pl-[260px]') : ''"
    >
      <GameNavBar v-if="showGameNav" />
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '~/player/stores/auth'
import Sidebar from '~/player/components/Sidebar.vue'
import GameNavBar from '~/player/components/GameNavBar.vue'

const auth = useAuthStore()
const route = useRoute()

const BROWSE_ROUTES = ['providers', 'categories', 'games']

function initCollapsed() {
  const stored = localStorage.getItem('player_sidebar_collapsed')
  if (stored !== null) return stored === '1'
  return typeof window !== 'undefined' && window.innerWidth < 768
}

const sidebarCollapsed = ref(initCollapsed())

const showNav = computed(() => auth.isAuthenticated && !route.meta.hideNav)
const showGameNav = computed(() => showNav.value && BROWSE_ROUTES.includes(route.name))

onMounted(() => {
  if (auth.isAuthenticated) auth.subscribeWallet(auth.token)
})
watch(
  () => auth.isAuthenticated,
  (v) => {
    if (v) auth.subscribeWallet(auth.token)
  }
)
</script>
